module.exports = __webpack_public_path__ + "img/1470270166.60ae63cb.jpg";